// Node modules
import { SlotEventConstants } from "@quest/slot-core";
import { Model as platformModel } from "@quest/platform-murka/dist/Model/Model";
import { ingenuity, dispatcher, Container, SpineBase, delayedCall, killDelayedCall, IObject } from "@quest/base-core/dist";

// Game modules
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { StackSymbolFeatureViewFG } from "./StackSymbolFeatureViewFG";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";

export class StackSymbolFeatureControllerFG {
  private view: StackSymbolFeatureViewFG;
  private stackSymMainContainer: Container;
  private startingIdOfSym: number = 0;
  private lengthOfStackSym: number = 0;
  private reelIDOfStackSym: number = 0;
  private allReelOffsets: number[][][] = [];
  private cloneSpineForAnim: SpineBase;
  private offsetsVal: number[][] = [];
  private winData: number[][] = [];
  private stackStartOffset: number[] = [];
  private newArr: number[][] = [];
  private stackUniqueOffset: number[][][] = [];
  private lastPlayedReel: number = 0;
  private stackAnimationArray: any[] = [];

  /**
  * StackSymbolFeatureControllerFG class constructor method
  * @param view 
  */
  constructor(view: StackSymbolFeatureViewFG) {
    this.view = view;
    this.view.visible = true;
    this.init();
  }

  /**
  * method init: initialize the other functions of StackSymbolFeatureControllerFG class.
  */
  private init(): void {
    this.subscribeEvent();
    this.initializeElements();
  }

  /**
   * method initializeElements: initialize elements to class components.
   */
  private initializeElements(): void {
    this.stackSymMainContainer = this.view.getContainerByID("stackSymMainContainer");
  }

  /**
   * Subscribe events
   */
  private subscribeEvent(): void {
    dispatcher.on(eventDispatchers.SHOW_LARGE_STACK_SYMBOL_FG, this.showLargeStackSymbolFG, this);
    dispatcher.on(eventDispatchers.HIDE_LARGE_STACK_SYMBOL_FG, this.resetElementsFG, this);
    dispatcher.on(eventDispatchers.PLAY_STACK_SYM_ANIM_FG, this.playStackSymAnimationFG, this);
    dispatcher.on(eventDispatchers.STOP_STACK_SYM_ANIM_FG, this.stopStackSymAnimatioFG, this);
  }

  /**
   * Unsubscribe events
   */
  private unSubscribeEvent(): void {
    dispatcher.off(eventDispatchers.SHOW_LARGE_STACK_SYMBOL_FG, this.showLargeStackSymbolFG, this);
    dispatcher.off(eventDispatchers.HIDE_LARGE_STACK_SYMBOL_FG, this.resetElementsFG, this);
    dispatcher.off(eventDispatchers.PLAY_STACK_SYM_ANIM_FG, this.playStackSymAnimationFG, this);
    dispatcher.off(eventDispatchers.STOP_STACK_SYM_ANIM_FG, this.stopStackSymAnimatioFG, this);
  }

  /**
   *  method showLargeStackSymbolFG: show stack symbol animations which participates in line win
   */
  private showLargeStackSymbolFG(): void {
    this.offsetsVal = (ingenuity.parserModel as GameParserModel).getStackSymOffsetsFG();
    this.winData = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    this.startingIdOfSym = 0;
    this.lengthOfStackSym = 0;
    this.reelIDOfStackSym = 0;
    this.stackUniqueOffset = []
    let commonElementsOffsets: number[][] = this.findCommonOffsets(this.offsetsVal, this.winData);

    if (commonElementsOffsets.length != 0) {
      for (let i: number = 0; i < (ingenuity.parserModel as platformModel).getReelGrid().length; i++) {
        const reelOffset: number[][] = this.checkbyReelID(commonElementsOffsets, i);
        this.stackStartOffset = [];
        if (reelOffset.length > 0) {
          let numberOFMAn: [number[], number] = this.checkForNumberOfStackInReel(reelOffset);
          let offset: number[] = numberOFMAn[0];
          let stackcount: number = numberOFMAn[1];
          this.newArr[offset[0]] = [offset[1], stackcount];
          this.setValuesForPlaySpine(reelOffset, offset, stackcount);
        }
      }
      this.moveToNextWinPresentation(commonElementsOffsets);

    }
    else {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
   *  method moveToNextWinPresentation: move to next win presentation
   * @param commonElementsOffsets
   */
  private moveToNextWinPresentation(commonElementsOffsets: number[][]): void {
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin(this.stackUniqueOffset);
    this.playStackSymAnimationFG();
  }

  /**
     * Method findCommonOffsets: return common offsets from single stack symbol offsets and line win symbol offsets
     * @param stackSymoffsetsVal
     * @param winDataOffsetVal
     * @returns 
     */
  private findCommonOffsets(stackSymoffsetsVal: number[][], winDataOffsetVal: number[][]) {
    const commonElements: number[][] = stackSymoffsetsVal.filter((element1: number[]) => {
      return winDataOffsetVal.some((element2: number[]) => {
        return element1[0] === element2[0] && element1[1] === element2[1];
      });
    });

    return commonElements;
  }

  /**
   * Method checkbyReelID: return reelID from common offsets
   * @param commonElementsOffset
   * @param reel
   * @returns
   */
  private checkbyReelID(commonElementsOffset: number[][], reel: number): number[][] {
    return commonElementsOffset.filter((innerArray: number[]) => innerArray[0] === reel);
  }

  /**
   * Method setValuesForPlaySpine: get values from offset for play transition animation on reel
   * @param firstOffset
   */
  private setValuesForPlaySpine(firstOffset: number[][], numberOFMAn: number[], stackcount: number): void {
    if (firstOffset.length > 0) {
      this.allReelOffsets.push(firstOffset);
      this.lengthOfStackSym = stackcount;
      this.reelIDOfStackSym = firstOffset[0][0];
      this.startingIdOfSym = numberOFMAn[1];
      this.playStackTransitionAnimation(this.reelIDOfStackSym + 1, this.lengthOfStackSym, this.startingIdOfSym);
    }
  }

  /**
   * Function is use to find out number of stack on current reelgrid
   * @param reelCommonOffsets 
   * @returns 
   */
  private checkForNumberOfStackInReel(reelCommonOffsets: number[][]): [any, number] {
    const stackOffset: number[][] = [];
    let number = 0;
    for (let i = 0; i < reelCommonOffsets.length - 1; i++) {
      if ((reelCommonOffsets[i][1]) + 1 === reelCommonOffsets[i + 1][1]) {

        stackOffset.push(reelCommonOffsets[i])
        if (i === reelCommonOffsets.length - 2) {
          stackOffset.push(reelCommonOffsets[i + 1])
        }


        if (this.stackStartOffset && this.stackStartOffset.length === 0) {
          this.stackStartOffset = reelCommonOffsets[i];
        }
        number++;

      }
      else {
        continue;
      }
    }
    stackOffset.length && this.stackUniqueOffset.push(stackOffset);

    return [this.stackStartOffset, number + 1];
  }

  /**
   *  method playStackTransitionAnimation: play stack symbol transition animation
   * @param reel
   * @param numOfSingleSym
   * @param col
   */
  private playStackTransitionAnimation(reel: number, numOfSingleSym: number, col: number): void {
    if (numOfSingleSym != 1) {
      if (this.lastPlayedReel < reel) {
        this.lastPlayedReel = reel;
      }
      this.stackSymMainContainer.visible = true;
      const cloneSpine: SpineBase = this.view.getSpineJsonAndCloneSym();
      const spineContainer: Container = this.view.getContainerByID(`Reel${reel}_1x${numOfSingleSym}_${col}_Container`);
      spineContainer.addChild(cloneSpine);
    }
  }

  /**
  *  method playStackSymAnimationFG: check stack reel, length for play stack animation
  */
  private playStackSymAnimationFG(): void {
    if (this.newArr.length != 0) {
      for (let i: number = 0; i < this.newArr.length; i++) {
        if (this.newArr[i] != null) {
          this.lengthOfStackSym = this.newArr[i][1];
          this.reelIDOfStackSym = i;
          this.startingIdOfSym = this.newArr[i][0];
          this.playStackSpineAnim(this.reelIDOfStackSym + 1, this.lengthOfStackSym, this.startingIdOfSym, i);
        }
      }
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    }

  }

  /**
   *  method playStackSpineAnim: play stack symbol animation
   * @param reel
   * @param numOfSingleSym
   * @param col
   */
  private playStackSpineAnim(reel: number, numOfSingleSym: number, col: number, length: number): void {
    const StackSpinePlayDelayTime: number = 100;
    const delayInNextPresentation: number = 1000;
    if (numOfSingleSym != 1) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.CHAR_UNITE, 1, false, gameConstants.SOUND_LIST_PRELOAD);
      this.stackSymMainContainer.visible = true;
      const spineContainer: Container = this.view.getContainerByID(`Reel${reel}_1x${numOfSingleSym}_${col}_Container`);
      spineContainer.visible = true;
      const cloneSpine: SpineBase = this.view.getStackTransitionClone();
      this.setStackEffectPos(cloneSpine, numOfSingleSym);
      spineContainer.addChild(cloneSpine);
      cloneSpine.visible = true;
      cloneSpine.playAnim(`1x${numOfSingleSym}`, false);
      cloneSpine.onComplete.addOnce(() => {
        cloneSpine.visible = false;
      }, this);

      // StackSpinePlayDelay is used to play spine with little delay after the transition spine start playing.
      delayedCall("StackSpinePlayDelay" + reel + col, StackSpinePlayDelayTime, () => {
        killDelayedCall("StackSpinePlayDelay");
        this.cloneSpineForAnim = spineContainer.children[0]
        this.stackAnimationArray.push([this.cloneSpineForAnim, `symbol_character1X${numOfSingleSym}_static`, `symbol_character1X${numOfSingleSym}`])
        this.cloneSpineForAnim.visible = true;
        this.cloneSpineForAnim.playAnim(`symbol_character1X${numOfSingleSym}_static`, false);
        (ingenuity.soundManager as any).playSound(SoundConstantGame.STACK_WIN, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        this.cloneSpineForAnim && this.cloneSpineForAnim.onComplete.addOnce(() => {
          if (length === this.newArr.length - 1) {
            delayedCall("delayInNextPresentation", delayInNextPresentation, () => {
              killDelayedCall("delayInNextPresentation");
              dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
              this.stackAnimationArray.length && this.stackAnimationArray.forEach((data: any) => {
                data[0].playAnim(data[2], true);
              }, this);
            })
          }
        })
      }, this);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    }
  }
 
  /**
   * This method is use to set stack effect position based on stack size 
   */
  private setStackEffectPos(cloneSpine: SpineBase, stackSize: number): void {
    let stackEffectJson: IObject = this.view.json["character_cascade_effect"];
    if (stackSize === 4) {
      cloneSpine.y = stackEffectJson.y4;
    } else if (stackSize === 3) {
      cloneSpine.y = stackEffectJson.y3;
    } else if (stackSize === 2) {
      cloneSpine.y = stackEffectJson.y2;
    }
  }

  /**
  *  method resetElements: reset data for stack symbol presentation
  */
  private resetElementsFG(): void {
    this.stackSymMainContainer.visible = false;
    this.allReelOffsets = [];
    this.offsetsVal = [];
    this.winData = [];
    this.lastPlayedReel = 0;
    this.newArr = [];
    (ingenuity.parserModel as GameParserModel).setStackSymPresentFG(false);
    for (let i: number = 0; i < this.stackSymMainContainer.children.length; i++) {
      this.stackSymMainContainer.children[i].visible = false;
      this.stackSymMainContainer.children[i].children = [];
      this.stackSymMainContainer.children[i].removeAll();
    }

  }

  /**
  *  method reset: reset event
  */
  public reset(): void {
    this.unSubscribeEvent();
  }
  /**
   * Function is use to stop stack symbol animation
   */
  private stopStackSymAnimatioFG(): void {
    this.stackAnimationArray.length && this.stackAnimationArray.forEach((data: any) => {
      data[0].playAnim(data[1], false);
    }, this);
  }
}
